import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { translationChunksConfig } from '@spartacus/assets';
import { AuthGuard, CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { FluDashboardBannerModule } from '../shared/modules/flu-dashboard-banner/flu-dashboard-banner.module';
import { CustomPipesModule } from '../shared/pipes/custom-pipes.module';
import { InvoicesComponent } from './invoices/invoices.component';
import { InvoicesMakePaymentComponent } from './make-payment/make-payment.component';
import { PaymentConfirmationComponent } from './payment-confirmation/payment-confirmation.component';
import { PaymentDetailsComponent } from './payment-details/payment-details.component';
import { PaymentHeaderComponent } from './payment-header/payment-header.component';
import { PaymentReviewComponent } from './payment-review/payment-review.component';
import { SelectGroupDirective } from "./directives/select-group.directive";
import { CheckChildrenDirective } from "./directives/check-children.directive";
import { InvoicesListComponent } from "./invoices-list/invoices-list.component";
import { CreditsListComponent } from "./credits-list/credits-list.component";
import { PaymentsDropdownComponent } from "../shared/components/payments-dropdown/payments-dropdown.component";
import { NoItemsDisclaimerComponent } from "./no-items-disclaimer/no-items-disclaimer.component";
import { PaymentMethodComponent } from "../shared/components/payment-method/payment-method.component";
import { IconModule, SpinnerModule } from "@spartacus/storefront";
import { PaginationComponent } from "./paginatotion/pagination.component";
import { PaymentsConfirmationInvoicesListComponent } from "./payments-confirmation-invoices-list/payments-confirmation-invoices-list.component";
import { PaymentsConfirmationCreditsListComponent } from "./payments-confirmation-credits-list/payments-confirmation-credits-list.component";

@NgModule({
  declarations: [
    InvoicesComponent,
    PaymentDetailsComponent,
    PaymentHeaderComponent,
    PaymentReviewComponent,
    PaymentConfirmationComponent,
    InvoicesMakePaymentComponent,
  ],
	imports: [
		CommonModule,
		NgbModule,
		RouterModule,
		NgbModule,
		I18nModule,
		FormsModule,
		ReactiveFormsModule,
		NgSelectModule,
		FluDashboardBannerModule,
		CustomPipesModule,
		FontAwesomeModule,
		ConfigModule.withConfig({
			cmsComponents: {
				MakePaymentComponent: {
					component: () =>
						import('./make-payment/make-payment.component').then(
							(m) => m.InvoicesMakePaymentComponent
						),
					guards: [AuthGuard]
				},
				OpenInvoicePaymentReviewComponent: {
					component: () =>
						import('./payment-review/payment-review.component').then(
							(m) => m.PaymentReviewComponent
						),
					guards: [AuthGuard]
				},
				AccountOpenInvoicePaymentComponent: {
					component: () =>
						import('./payment-details/payment-details.component').then(
							(m) => m.PaymentDetailsComponent
						),
					guards: [AuthGuard]
				},
				OpenInvoicePaymentConfirmationComponent: {
					component: () =>
						import(
							'./payment-confirmation/payment-confirmation.component'
							).then((m) => m.PaymentConfirmationComponent),
					guards: [AuthGuard]
				},
				AccountInvoiceComponent: {
					component: () =>
						import('./invoices/invoices.component').then(
							(m) => m.InvoicesComponent
						),
					guards: [AuthGuard]
				}
			},
			i18n: {
				backend: { loadPath: 'i18n-assets/{{lng}}/{{ns}}.json' }
			},
			chunks: translationChunksConfig
		} as CmsConfig),
		SelectGroupDirective,
		CheckChildrenDirective,
		InvoicesListComponent,
		CreditsListComponent,
		PaymentsDropdownComponent,
		NoItemsDisclaimerComponent,
		PaymentMethodComponent,
		IconModule,
		PaginationComponent,
		SpinnerModule,
		PaymentsConfirmationInvoicesListComponent,
		PaymentsConfirmationCreditsListComponent,
		UrlModule
	]
})
export class CustomMakeAPaymentModule {}
